import React, { useState } from "react";
import { MapPin } from "lucide-react";
import WorkshopPicker from "@/components/WorkshopPicker";

export default function RepairPoints() {
  const [, setSelectedId] = useState("");

  return (
    <div className="tk-container py-16" data-testid="repair-points-page">
      <p className="tk-overline mb-3">Verksteder</p>
      <h1 className="text-3xl sm:text-4xl font-semibold mb-3">Tekkdeler repair points</h1>
      <p className="text-sm text-slate-500 mb-10 max-w-xl">
        Uavhengige, håndplukkede verksteder. Søk på postnummer eller bruk din nåværende
        posisjon for å finne det nærmeste.
      </p>

      <WorkshopPicker
        selectedId=""
        onSelect={setSelectedId}
        emptyMessage="Ingen verksteder tilgjengelig akkurat nå — nye åpner snart."
        renderItem={(f) => (
          <div
            key={f.id}
            className="tk-card tk-card-interactive"
            data-testid={`fixer-card-${f.id}`}
          >
            <div className="flex items-start justify-between gap-3 mb-2">
              <p className="tk-overline text-[#4A7C59]">{f.postal_code}</p>
              {typeof f.distance_km === "number" && (
                <span className="text-xs text-slate-500">{f.distance_km} km</span>
              )}
            </div>
            <h3 className="text-lg font-semibold mb-2 leading-snug">{f.display_name}</h3>
            <p className="text-sm text-slate-500 mb-3 flex items-start gap-1">
              <MapPin size={14} className="mt-0.5" /> {f.address}, {f.postal_code}
            </p>
            <p className="text-xs text-slate-500">
              Spesialiserer på: {(f.specializations || []).join(", ")}
            </p>
          </div>
        )}
      />
    </div>
  );
}
